<template></template>

<script>
    export default {

        name: 'GoogleAnalytics',

        data() {
            return {
                debug: false,
                script: 'https://www.google-analytics.com/analytics.js',
                property: null,
                referrer: null,
                gaReferral: null,
                trackingVersion: 'dev-undefined',
                gaLoaded: false,
                trackerCreated: false,
                queue: [],
                heartBeatCount: 0,

                cdObject: {},
                shadowCdObject: {},

                customDimensions: {

                    //ZUORDNUNG
                    'format': { cd: 1, default: 'na' },
                    'formatId': { cd: 52, default: 'na' },
                    'videoID': { cd: 2, default: 'na' },
                    'episode': { cd: 3, default: 'na' },
                    'validFrom': { cd: 4, default: 'na' },
                    'contentID': { cd: 5, default: 'na' },
                    'bobyID': { cd: 6, default: 'na' },
                    'episodeNumber': { cd: 7, default: 'na' },

                    //WHERE AM I
                    'hostname': { cd: 8, default: 'na' },
                    'tld': { cd: 9, default: 'na' },
                    'url': { cd: 10, default: 'na' },

                    //VERWEILDAUER
                    'V_Block': { cd: 11, default: 'na' },
                    'V_Posrel': { cd: 12, default: 'na' },
                    'V_Posrel_kap': { cd: 13, default: 'na' },
                    'V_Posabs': { cd: 14, default: 'na' },
                    'V_Posabs_kap': { cd: 15, default: 'na' },
                    'V_Nutzungsdauer': { cd: 16, default: 'na', metric: false }, // im 1min Raster (nur bei Min Messung) - 60 sonst na
                    'V_Initialstart': { cd: 17, default: 'na', metric: false }, // bei start des videos 1, sonst 0

                    //META
                    'V_Titel': { cd: 18, default: 'na' },
                    'V_Laenge': { cd: 1, default: 0, metric: true },
                    'V_Videolaenge': { cd: 20, default: 'na' },
                    'V_ID': { cd: 21, default: 'na' },
                    'V_Season_Episode': { cd: 22, default: 'na' },
                    'V_Contentlieferung': { cd: 23, default: 'na' },

                    //ADS
                    'V_Adslot': { cd: 24, default: 'na' },
                    'Site_Zone': { cd: 25, default: 'na' },

                    //CONTENT
                    'V_Starttyp': { cd: 26, default: 'na' }, // Starttyp des Contentvideos - auto, user, playlist (Heartbeat Reporting)

                    //Recommendation
                    'Reco': { cd: 27, default: 'na' }, //gravity, outbrain,  ...

                    //USER DATA (which user?)
                    'Loginstatus': { cd: 28, default: 'na' },
                    'User_ID': { cd: 29, default: 'na' },

                    'V_Playertyp': { cd: 30, default: 'na' }, //html5_fallback, html5_bitdash, flash, exo, ...

                    //BANDWIDTH
                    'V_Bitrate': { cd: 31, default: 'na' },
                    'V_Netztyp': { cd: 32, default: 'na' },

                    //WATCHBOX
                    'V_FSK': { cd: 33, default: 'na' },
                    'V_Genre': { cd: 34, default: 'na' },
                    'V_Form': { cd: 35, default: 'na' },
                    'V_Bewegtbildklasse': { cd: 36, default: 'na' },
                    'V_Typ': { cd: 37, default: 'na' },
                    'V_Clipfish-Video-ID': { cd: 38, default: 'na' },

                    //NOW
                    'V_Kapitel': { cd: 39, default: 'na' },
                    'V_Playstatus': { cd: 40, default: 'na' },
                    'Userstatus': { cd: 41, default: 'na' }, // free, plus, trial
                    'V_Videolounge_Heimatkategorie': { cd: 42, default: 'na' },  // Heimatkategorie des Videos in d Videolounge (dsds, ibens, etc)

                    //MORE DATA
                    'V_Adblocker_aktiv': { cd: 43, default: 'na' }, // 0,1,na
                    'val': { cd: 44, default: '4fg209fgjwnchtr' }, // shared secret for anti spam
                    'V_Zaehlpixel_Version': { cd: 45, default: 'na' }, // internal tracking concept version number
                    'ApiSource':  { cd: 46, default: 'na' }, // vipo, boby, hls, ...
                    'PlayerSichtbarkeit':  { cd: 47, default: 'na' }, // vipo, boby, hls, ...
                    'Homad': { cd: 48, default: 'na' } // SvM Plugin activated
                },

                trackableJWEvents: {
                    'jwReady': { name: 'ready', options: { } },
                    'jwSetupError': { name: 'setupError', options: { } },
                    'jwError': { name: 'error', options: { } },
                    'jwAdError': { name: 'adError', options: { } },
                    'jwAdBlock': { name: 'adBlock', options: { } },
                    'jwAdRequest': { name: 'adRequest', options: { } },
                    'jwAdImpression': { name: 'adImpression', options: { } },
                    'jwAdPlay': { name: 'adPlay', options: { } },
                    'jwAdPause': { name: 'adPause' },
                    'jwAdComplete': { name: 'adComplete', options: { } },
                    'jwAdClick': { name: 'adClick' },
                    // 'jwAdMeta': { name: 'adMeta', options: { } },
                    // 'jwPlayAttempt': { name: 'playAttempt', options: { } },
                    // 'jwBeforePlay': { name: 'beforePlay', options: { } },
                    'jwPlay': { name: 'play' },
                    // 'jwBuffer': { name: 'buffer', options: { } },
                    // 'jwBufferChange': { name: 'bufferChange', options: { } },
                    // 'jwBufferFull': { name: 'bufferFull', options: { } },
                    'jwFirstFrame': { name: 'view', options: { } },
                    'jwPause': { name: 'pause' },
                    // 'jwBeforeComplete': { name: 'beforeComplete', options: { } },
                    'jwComplete': { name: 'complete', options: { } },
                    'jwPlaylistComplete': { name: 'playlistComplete', options: { } },
                    // 'jwMute': { name: 'mute' },
                    // 'jwFullscreen': { name: 'fullscreen' },
                    // 'jwResize': { name: 'resize' },
                    // 'jwSeek': { name: 'seek' },
                    'jwSeeked': { name: 'seeked', options: { } },
                    // 'jwMeta': { name: 'meta', options: { } },
                    // 'jwTime': { name: 'time', options: { } },
                    // 'jwPlaylist': { name: 'playlist' },
                    // 'jwPlaylistItem': { name: 'playlistItem' },
                    // 'jwProviderChanged': { name: 'providerChanged' },
                    // 'jwLevels': { name: 'levels' },
                },

                trackableHomadEvents: {
                    // 'hdPenalty': { 'name': 'homadPenalty', options: {} }, // penalty function has been called, due to blocked functionality
                    // 'hdVpaid': { 'name': 'homadVpaid', options: {} }, // HOMAD recieved a VPAID response
                    // 'hdContinueContent': { 'name': 'homadContinueContent', options: {} }, // resume content video
                    // 'hdContentPlayerPlay': { 'name': 'homadContentPlayerPlay', options: {} }, // HOMAD called play on content player
                    // 'hdContentPlayerPause': { 'name': 'homadContentPlayerPause', options: {} }, // HOMAD called pause on content player
                    // 'hdAdSkipped': { 'name': 'adSkipped', options: {} }, // ad has been skipped
                    'hdAdRequest': { 'name': 'adRequest', options: {} }, // ad is requested by the player
                    'hdAdError': { 'name': 'adError', options: {} },
                    'hdAdImpression': { 'name': 'adImpression', options: {} }, // HOMAD ad delivery impressions called
                    // 'hdAdStart': { 'name': 'adStart', options: {} }, // HOMAD ad delivery started
                    // 'hdAdTime': { 'name': 'adTime', options: {} }, // ad playback is in progress
                    // 'hdAdFirstQuartile': { 'name': 'adFirstQuartile', options: {} }, // HOMAD ad delivery first quartile
                    // 'hdAdMidPoint': { 'name': 'adMidPoint', options: {} }, // HOMAD ad delivery mid point reached
                    // 'hdAdThirdQuartile': { 'name': 'adThirdQuartile', options: {} }, // HOMAD ad delivery third quartile
                    'hdAdComplete': { 'name': 'adComplete', options: {} }, // HOMAD ad delivery completed
                    'hdAdPlay': { 'name': 'adPlay', options: {} }, // ad is played
                    'hdAdPause': { 'name': 'adPause', options: {} }, // ad is paused
                    'hdAdClick': { 'name': 'adClick', options: {} }, // HOMAD detected click on ad video
                },

                shadowEvents: ['ready', 'view', 'heartbeat'],

                shadowGaObject: {},

                shadowDimensions: {

                    //ZUORDNUNG
                    'format': { cd: 1, default: 'na' },
                    // 'formatId': { cd: 52, default: 'na' },
                    'videoID': { cd: 2, default: 'na' },
                    'episode': { cd: 3, default: 'na' },
                    'validFrom': { cd: 4, default: 'na' },
                    'contentID': { cd: 5, default: 'na' },
                    'bobyID': { cd: 6, default: 'na' },
                    'episodeNumber': { cd: 7, default: 'na' },

                    //WHERE AM I
                    'hostname': { cd: 8, default: 'na' },
                    'tld': { cd: 9, default: 'na' },
                    'url': { cd: 10, default: 'na' },

                    //VERWEILDAUER
                    'V_Block': { cd: 11, default: 'na' },
                    'V_Posrel': { cd: 12, default: 'na' },
                    'V_Posrel_kap': { cd: 13, default: 'na' },
                    'V_Posabs': { cd: 14, default: 'na' },
                    'V_Posabs_kap': { cd: 15, default: 'na' },
                    'V_Nutzungsdauer': { cd: 16, default: 'na', metric: false }, // im 1min Raster (nur bei Min Messung) - 60 sonst na
                    'V_Initialstart': { cd: 17, default: 'na', metric: false }, // bei start des videos 1, sonst 0

                    //META
                    'V_Titel': { cd: 18, default: 'na' },
                    // 'V_Laenge': { cd: 1, default: 0, metric: true },
                    'V_Videolaenge': { cd: 20, default: 'na' },
                    /*
                    'V_ID': { cd: 21, default: 'na' },
                    'V_Season_Episode': { cd: 22, default: 'na' },
                    'V_Contentlieferung': { cd: 23, default: 'na' },

                    //ADS
                    'V_Adslot': { cd: 24, default: 'na' },
                    'Site_Zone': { cd: 25, default: 'na' },

                    //CONTENT
                    'V_Starttyp': { cd: 26, default: 'na' }, // Starttyp des Contentvideos - auto, user, playlist (Heartbeat Reporting)

                    //Recommendation
                    'Reco': { cd: 27, default: 'na' }, //gravity, outbrain,  ...

                    //USER DATA (which user?)
                    'Loginstatus': { cd: 28, default: 'na' },
                    'User_ID': { cd: 29, default: 'na' },

                    'V_Playertyp': { cd: 30, default: 'na' }, //html5_fallback, html5_bitdash, flash, exo, ...

                    //BANDWIDTH
                    'V_Bitrate': { cd: 31, default: 'na' },
                    'V_Netztyp': { cd: 32, default: 'na' },

                    //WATCHBOX
                    'V_FSK': { cd: 33, default: 'na' },
                    'V_Genre': { cd: 34, default: 'na' },
                    'V_Form': { cd: 35, default: 'na' },
                    'V_Bewegtbildklasse': { cd: 36, default: 'na' },
                    'V_Typ': { cd: 37, default: 'na' },
                    'V_Clipfish-Video-ID': { cd: 38, default: 'na' },

                    //NOW
                    'V_Kapitel': { cd: 39, default: 'na' },
                    'V_Playstatus': { cd: 40, default: 'na' },
                    'Userstatus': { cd: 41, default: 'na' }, // free, plus, trial
                    'V_Videolounge_Heimatkategorie': { cd: 42, default: 'na' },  // Heimatkategorie des Videos in d Videolounge (dsds, ibens, etc)

                    //MORE DATA
                    'V_Adblocker_aktiv': { cd: 43, default: 'na' }, // 0,1,na
                    'val': { cd: 44, default: '4fg209fgjwnchtr' }, // shared secret for anti spam
                    'V_Zaehlpixel_Version': { cd: 45, default: 'na' }, // internal tracking concept version number
                    'ApiSource':  { cd: 46, default: 'na' }, // vipo, boby, hls, ...
                    'PlayerSichtbarkeit':  { cd: 47, default: 'na' }, // vipo, boby, hls, ...
                    'Homad': { cd: 48, default: 'na' } // SvM Plugin activated

                     */
                },

                sessionIdCookieName: '__cssid',
                sessionId: null,


            }
        },

        mounted() {
            this.$l.log('GA component mounted', this.$settings.googleAnalytics)
            this.init()
        },

        methods: {

            init() {

                this.$l.log('GA init()')

                var vm = this;

                this.setupShadowCookie();

                if(this.$settings.googleAnalytics.debug) {
                    this.setupDebugging()
                }

                this.listenToReferrer()
                this.requestReferrer()

                this.property = this.$settings.googleAnalytics.property
                this.trackingVersion = this.$settings.googleAnalytics.trackingVersion || this.trackingVersion

                this.prepareAnalytics()
                this.setupEventListeners()
                this.presetCustomDimensions()
                this.setupCustomDimensions()
                this.setupHeartBeat()

                this.$manager.vendorGrant('5e542b3a4cd8884eb41b5a72').then(function(grants){
                    if(grants) {
                        vm.$l.log('GA granted by consent tool (vendorGrant)')
                        vm.loadAnalytics();
                    }
                    else {
                        vm.$l.log('GA NOT granted by consent tool (vendorGrant)')
                    }

                })
                // this.loadAnalytics()
                // setTimeout(this.loadAnalytics, 5000);

                // testing delay
                setTimeout(this.createTracker, 3000);
            },

            setupShadowCookie() {
                if (document.cookie.indexOf(this.sessionIdCookieName + "=") < 0) {
                    this.sessionId = this.$helpers.uuidv4();
                    const sessionExpiration = new Date(+new Date() + 1000 * 60 * 30); // 30 Minuten
                    document.cookie = this.sessionIdCookieName + '=' + this.sessionId + ';expires=' + sessionExpiration.toGMTString() + ';path=/';
                } else {
                    this.sessionId = this.$helpers.getCookie(this.sessionIdCookieName);
                }
            },

            listenToReferrer() {
              // Listener für Referrer der Parent Seite
              var vm = this;
              window.addEventListener('message', function(event) {
                  if(event.data.action == 'sendReferrer') {
                      vm.$l.log("receiving referrerData", event.data)

                      if(event.data && event.data.hasOwnProperty('gaReferral')) {
                          //data from parent.js (umtz_cookie)
                          vm.setGaReferral(event.data.gaReferral)
                      }
                      else if(event.data && event.data.hasOwnProperty('referrer')) {
                          // normal referrer, error prone ... :(
                          vm.setReferrer(event.data.referrer)
                      }
                  }
              });
            },

            requestReferrer() {
              window.parent.postMessage({action: 'reqReferrer'}, '*');
            },

            setGaReferral(gaReferral) {

                this.$l.log('GA setGaReferral()', gaReferral)

                if ( !this.trackerCreated || typeof ga !== 'function') {
                    this.gaReferral = gaReferral
                    return
                }

                var fieldMap = {
                    'utmcsr': 'campaignSource',
                    'utmcmd': 'campaignMedium',
                    'utmccn': 'campaignName',
                    'utmcct': 'campaignContent',
                    'utmctr': 'campaignKeyword',
                    // 'utmgclid': '',
                    // 'utmdclid': '',
                    'referrer': 'referrer',
                };

                for (var key in gaReferral) {

                    if (typeof gaReferral[key] !== 'undefined' && typeof fieldMap[key] !== 'undefined') {
                        ga('set', fieldMap[key], gaReferral[key]);
                        this.shadowGaObject[fieldMap[key]] = gaReferral[key];
                    }

                }

                this.$l.log('GA setGaReferral()', gaReferral)
            },

            setReferrer(referrer) {
                this.$l.log('GA setReferrer()', referrer)

                var embedLocation = (this.$helpers.inIframe()) ? document.referrer : location.href;
                var embedHostname = this.$helpers.stripDomain(embedLocation)
                var referrerHostname = this.$helpers.stripDomain(referrer)

                // prevent self-referral
                if( referrer && referrer != '' && embedHostname != referrerHostname ) {

                    this.$l.log('GA setReferrer() valid', referrer)

                    this.referrer = referrer

                    // if the tracker has already been created, set it now via ga
                    if ( this.trackerCreated && typeof ga === 'function') {
                        ga('set', 'referrer', referrer);
                        this.shadowGaObject.referrer = referrer;
                    }
                }
                else {
                    this.referrer = null

                    // if the tracker has already been created, set it now via ga
                    if ( this.trackerCreated && typeof ga === 'function') {
                        ga('set', 'referrer', null);
                        this.shadowGaObject.referrer = null;
                    }
                }

            },

            setupDebugging() {
                this.debug = true
                this.script = 'https://www.google-analytics.com/analytics_debug.js'
                window.ga_debug = {trace: true};
            },

            prepareAnalytics() {
                if (typeof ga !== 'function') {

                    this.$l.log('GA preparing');

                    (function (i, s, o, g, r, a, m) {
                        i['GoogleAnalyticsObject'] = r;
                        i[r] = i[r] || function () {
                            (i[r].q = i[r].q || []).push(arguments)
                        }, i[r].l = 1 * new Date();
                    })(window, document, 'script', this.script, 'ga');

                    this.$events.emit('gaPrepared')
                }
                else {
                    this.$warn('GA already prepared?')
                }
            },

            loadAnalytics() {

                if (!this.$manager.get('googleAnalytics.active')) {
                    this.$l.log('GA is NOT active, prevent loading script');
                    return;
                }

                var vm = this

                if ( !this.gaLoaded ) {

                    this.$l.log('GA loading script');

                    (function (i, s, o, g, r, a, m) {
                        i['GoogleAnalyticsObject'] = r;
                        i[r] = i[r] || function () {
                            (i[r].q = i[r].q || []).push(arguments)
                        }, i[r].l = 1 * new Date();
                        a = s.createElement(o),
                            m = s.getElementsByTagName(o)[0];
                        a.async = 1;
                        a.src = g;
                        m.parentNode.insertBefore(a, m)
                    })(window, document, 'script', vm.script, 'ga');

                    this.gaLoaded = true
                    this.$events.emit('gaLoaded')
                }
                else {
                    this.$warn('GA already loaded?')
                }
            },

            createTracker( clientId ) {

                if (!this.$manager.get('googleAnalytics.active')) {
                    this.$l.log('GA is NOT active, prevent creating tracker');
                    return;
                }

                // tracker has already been created, exit ...
                if(this.trackerCreated) return

                this.$l.log('GA createTracker()', clientId)

                clientId = clientId || false

                if(clientId) {
                    // create tracker with existing clientId
                    ga('create', this.property, 'auto', {
                        clientId: clientId,
                        location: (this.$helpers.inIframe()) ? document.referrer : location.href
                    });
                }
                else {
                    // create standalone tracker
                    ga('create', this.property, 'auto', {
                        location: (this.$helpers.inIframe()) ? document.referrer : location.href
                    });
                }

                // tracker has been created
                this.trackerCreated = true

                ga('set','location', (this.$helpers.inIframe()) ? document.referrer : location.href)

                // this prevents actual tracking ... like a dry run
                if(this.$settings.googleAnalytics.dry) {
                    ga('set', 'sendHitTask', null);
                }

                // inside the iframe, we need to use the referrer of the parent page
                if(this.$helpers.inIframe()) {

                    if(this.gaReferral) {
                        // we have more advanced referral data from utmz cookie
                        this.setGaReferral(this.gaReferral)
                    }
                    else {
                        // we set the referrer (may even be null)
                        this.$l.log('GA setting referrer to', this.referrer)
                        ga('set', 'referrer', this.referrer);
                    }

                }

                // emit event that tracker has been created
                this.$events.emit('gaTrackerCreated')
            },



            runQueued() {
                this.$l.log('runQueued()')

                for (var i = 0; i < this.queue.length; i++) {

                    var queueItem = this.queue[i]

                    switch(queueItem.event) {
                        case 'cd':
                            this.setCD(queueItem.cdName, queueItem.cdValue)
                            break

                        case 'track':
                            this.track(queueItem.eventName, queueItem.eventOptions)
                            break
                    }
                }
            },

            setupEventListeners() {
                this.$events.on(Object.keys(this.trackableJWEvents), this.onJWEvent)
                this.$events.on(Object.keys(this.trackableHomadEvents), this.onHomadEvent)
            },

            presetCustomDimensions() {
                for(var label in this.customDimensions) {
                    var cd = this.customDimensions[label]

                    this.setCD(label, cd.default)
                }
            },

            setupCustomDimensions() {

                var embedLocation = (this.$helpers.inIframe()) ? document.referrer : location.href;

                // Shared Secret zur Anti Spam Validierung
                this.setCD('val', '4fg209fgjwnchtr')

                // Version des Messkonzepts
                this.setCD('V_Zaehlpixel_Version', this.trackingVersion)

                this.setCD('V_Starttyp', this.$settings.jwOptions.autostart)


                this.setCD('url', embedLocation)
                this.setCD('tld', this.$helpers.topLevelDomain(embedLocation))
                this.setCD('hostname', this.$helpers.stripDomain(embedLocation))

            },

            setupHitSpecificCustomDimensions() {

                this.setCD('V_Playertyp', this.$jwplayer.getProvider().name)

                this.setCD('ApiSource', this.$item.source)
                this.setCD('V_ID', this.$item.id)
                this.setCD('videoID', this.$item.id)
                this.setCD('V_Titel', this.$item.title)
                this.setCD('format', this.$item.format)
                this.setCD('formatId', this.$item.formatId)
                this.setCD('V_Videolaenge', this.$item.duration)
                this.setCD('Site_Zone', this.$item.adZone)


                this.setCD('PlayerSichtbarkeit', this.$jwplayer.getViewable())


                if (this.$jwcomp.state && this.$jwcomp.state != 'idle') {

                    var percentage = this.$jwplayer.getPosition() / this.$jwplayer.getDuration()

                    this.$l.log('position', this.$jwplayer.getPosition(), Math.floor(this.$jwplayer.getPosition() / 60))

                    this.setCD('V_Posrel', Math.ceil( percentage / 0.25 ) ) // V_Quartile
                    this.setCD('V_Posabs', Math.floor(this.$jwplayer.getPosition() / 60)) // V_Minute
                }
                else {
                    this.setCD('V_Posrel', "na")
                    this.setCD('V_Posabs', "na")
                    // this.setCD( 'V_Posrel_kap', null )
                    // this.setCD( 'V_Posabs_kap', null )
                }
            },

            setupEventSpecificCustomDimensions(evt) {
                this.setCD('V_Adslot', null)

                switch (evt.type) {

                    case 'adRequest':
                        this.setCD('V_Adslot', evt.adposition) // "pre"
                        this.setCD('V_Adslot', evt.offset) // "pre"
                        break;

                    case 'adImpression':
                    case 'adPlay':
                    case 'adComplete':
                        this.setCD('V_Adslot', evt.adschedule.breakid) // "preroll"
                        // this.setCD( 'V_Adslot', evt.adschedule.offset ) // "pre"
                        // this.setCD( 'V_Adslot', evt.adschedule.item ) // 1
                        break;

                }

            },

            track(eventName, eventOptions) {

                eventOptions = eventOptions || {}
                this.$l.log('GA tracking', eventName, eventOptions)

                this.setupHitSpecificCustomDimensions()

                if ( this.trackerCreated && typeof ga === 'function') {
                    // if(this.$settings.googleAnalytics.dry) {
                    //     this.$l.log('GA dry run')
                    // }
                    // else {
                    //     ga('send', 'event', 'VueJWPlayer8', eventName, this.$item.title, eventOptions);
                    // }

                    ga('send', 'event', 'VueJWPlayer8', eventName, this.$item.title, eventOptions);
                    this.$l.log('GA tracking DONE', eventName, eventOptions)
                }
                else {
                    this.$l.log('GA track() DELAYED', eventName)
                    this.queue.push({ event: 'track', eventName: eventName, eventOptions: eventOptions })
                }

                this.shadowTrack(eventName, eventOptions);
            },

            shadowTrack(eventName, eventOptions) {
                if(!this.$settings.shadowTracking.active) {
                    return;
                }

                if(this.shadowEvents.indexOf(eventName) === -1) {
                    return;
                }

                var event = {
                    "au": "1",
                    "ht": 'event',
                    "ec": 'VueJWPlayer8',
                    "ea": eventName,
                    "el": this.$item.title,
                    // eventValue: eventOptions
                    "r": this.shadowGaObject.referrer || document.referrer,
                    "c": this.sessionId,
                    "l": (this.$helpers.inIframe()) ? document.referrer : location.href,
                    // "h": pageUrl.hostname,
                    // "p": pageUrl.pathname, // + pageUrl.search
                    "t": document.title,
                }

                event = this.$helpers.assign(event, this.shadowCdObject);

                this.$l.log('GA shadowTrack', event);


                const xhr = new XMLHttpRequest();
                xhr.open('POST', this.$settings.shadowTracking.url);
                xhr.setRequestHeader('Content-Type', 'application/json');
                xhr.send(JSON.stringify(event));

                // ec, ea, el

            },

            // set a custom Dimension value
            setCD(cdName, cdValue) {

                if (typeof(cdValue) == 'undefined') {
                    // no value
                    this.$l.log('setCD_Error - no value', cdName, cdValue)
                    return
                }

                var cd = this.customDimensions[cdName] || false

                if(!cd) {
                  // no such cd
                  this.$l.log('setCD_Error - no such cd', cdName, cdValue)
                  return
                }

                if ( this.trackerCreated && typeof ga === 'function') {
                    // this.$l.log('GA setCD() SETTING', cdName, cdValue)
                    ga('set', (cd.metric ? 'metric' : 'dimension') + (cd.cd), cdValue)
                }
                else {
                    this.$l.log('GA setCD() DELAYED', cdName, cdValue)
                    this.queue.push({ event: 'cd', cdName: cdName, cdValue: cdValue })
                }

                var shadowCd = this.shadowDimensions[cdName] || false
                if(shadowCd) {
                    this.shadowCdObject[ (shadowCd.metric ? 'sm' : 'sd') + (shadowCd.cd) ] = cdValue ? cdValue.toString() : '';
                }

                this.cdObject[ (cd.metric ? 'cm' : 'cd') + (cd.cd) ] = cdValue;
            },

            onJWEvent(evt) {

                if (typeof(evt.type) != 'undefined') {
                    evt.eventName = 'jw' + evt.type[0].toUpperCase() + evt.type.substring(1)
                    evt.event = this.trackableJWEvents[evt.eventName] || {}
                    evt.eventOptions = evt.event.options || {}
                }

                this.$l.log('GA onJWEvent', evt.eventName, evt.type, evt)
                this.setupEventSpecificCustomDimensions(evt)
                this.track(evt.event.name, evt.eventOptions)
            },

            onHomadEvent(evt) {

                if (typeof(evt.name) != 'undefined') {
                    evt.eventName = 'hd' + evt.name[0].toUpperCase() + evt.name.substring(1)
                    evt.event = this.trackableHomadEvents[evt.eventName] || {}
                    evt.eventOptions = evt.event.options || {}

                    // fill the fields that are expected from JWEvents,
                    // in this case evt.state contains "preroll", or "postroll" ...
                    evt.adposition = evt.state
                    evt.offset = evt.state
                    evt.adschedule = {breakid: evt.state}
                }

                this.$l.log('GA onHomadEvent', evt.eventName, evt.name, evt)
                this.setupEventSpecificCustomDimensions(evt)
                this.track(evt.event.name, evt.eventOptions)
            },

            setupHeartBeat() {
                setInterval(this.heartBeat, 1000)
            },

            heartBeat() {
                if(this.$jwcomp && this.$jwcomp.state == 'playing' && this.$jwcomp.adState != 'playing') {
                    this.heartBeatCount++

                    if( this.heartBeatCount % 10 == 0 ) {
                        this.$l.log('tracking heartBeat', this.heartBeatCount)
                        this.track('heartbeat', {
                            nonInteraction: true,
                            metric2: 10
                        })
                    }
                }
            }
        },

        events: {

            gaTrackerCreated() {
                //ready to track now
                this.runQueued();
            },

            jwReady(evt) {
            },

            jwPlay(evt) {
            },

            jwMeta(evt) {
                if(evt.duration) {
                    this.setCD('V_Laenge', Math.floor(evt.duration))
                }
            },

            jwVisualQuality(evt) {
                this.setCD('V_Bitrate', evt.level.bitrate / 1000)
            },

            jwAdBlock(evt) {
                this.setCD('V_Adblocker_aktiv', 1)
                this.$l.log('AdBlocker detected ...')
            },

            jwViewable(evt) {
                this.$l.log('Viewability changed ...', evt)
            },

            newItemData(evt) {
                this.$l.log('received newItemData event')
                this.setupCustomDimensions()
            },

            hdEvent(evt) {
                this.setCD('Homad', 1)
            }

        }

    }
</script>



// WEBPACK FOOTER //
// src/components/tracking/GoogleAnalytics.vue